export const streetParkingCostAllTimeSelector = ({streetParkingCostAllTime}) => streetParkingCostAllTime